import script from "./MemberAdd.vue?vue&type=script&setup=true&lang=js"
export * from "./MemberAdd.vue?vue&type=script&setup=true&lang=js"

import "./MemberAdd.vue?vue&type=style&index=0&id=645dcf18&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-645dcf18"]])

export default __exports__